module.exports = {"510525100":"古蔺镇","510525101":"龙山镇","510525102":"永乐镇","510525103":"太平镇","510525104":"二郎镇","510525105":"大村镇","510525106":"石宝镇","510525107":"丹桂镇","510525108":"水口镇","510525109":"观文镇","510525110":"双沙镇","510525111":"德耀镇","510525112":"护家镇","510525113":"石屏镇","510525114":"土城镇","510525115":"皇华镇","510525202":"鱼化乡","510525204":"东新乡","510525207":"白泥乡","510525208":"椒园乡","510525209":"马嘶苗族乡","510525211":"马蹄乡","510525212":"箭竹苗族乡","510525214":"大寨苗族乡","510525215":"桂花乡","510525216":"黄荆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510525.json
// module id = 2112
// module chunks = 0